import { useMutation, useQuery } from "@apollo/client";
import { Button, Drawer, message } from "antd";
import React, { useEffect, useState } from "react";
import { UPDATE_SUBSCRIPTION } from "../../../Graphql/mutations";
import { GET_PRICE_PACKAGES_LIST } from "../../../Graphql/queries";

import "./PlanUpgradeModal.css";

const PlanUpgradeModal = ({
  showPlanUpgradeDrawer,
  setShowPlanUpgradeDrawer,
  subscriptionData,
  pricePackageData,
  reloadUpcomingInvoiceData,
}) => {
  const [packageList, setPackageList] = useState([]);
  const { data: PackageData, loading: packageLoading } = useQuery(
    GET_PRICE_PACKAGES_LIST,
    {
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const [UPDATE_SUBSCRIPTION_MUTATION, { loading: isUpdatingSubscription }] =
    useMutation(UPDATE_SUBSCRIPTION);
  useEffect(() => {
    if (PackageData) {
      const reducedData = PackageData.packages.reduce((acc, curr) => {
        const allValues = curr.package_prices.flatMap((singlePackage) => {
          let singlePackageObj = [];
          let alternate_plan = curr.package_prices.filter(
            ({ billing_period }) =>
              billing_period === singlePackage.billing_period
          )[0];
          singlePackageObj.push({
            free_trial_days: singlePackage.free_trial_days,
            price: singlePackage.price,
            stripe_price_id: singlePackage.stripe_price_id,
            allow_custom_task: curr.allow_custom_task,
            allow_qr_code: curr.allow_qr_code,
            billing_period: singlePackage.billing_period,
            name: curr.name,
            id: alternate_plan.id,
            price_description: alternate_plan.price_description,
          });
          return singlePackageObj;
        });
        return [...acc, ...allValues];
      }, []);
      setPackageList(reducedData);
    }
  }, [PackageData]);

  const onClosePlanUpgradeDrawer = () => {
    setShowPlanUpgradeDrawer(false);
  };

  const onChoosePlan = async (priceId) => {
    const isUpdateSuccessful = await UPDATE_SUBSCRIPTION_MUTATION({
      variables: {
        price_id: priceId,
        locations: subscriptionData.quantity,
        status: "",
      },
    });
    if (!isUpdateSuccessful.errors) {
      message.success("Upgrade Requested Successfully!");
      reloadUpcomingInvoiceData();
      setShowPlanUpgradeDrawer(false);
    } else {
      isUpdateSuccessful.errors.forEach((e) => {
        return message.error(e.message);
      });
      setShowPlanUpgradeDrawer(false);
    }
  };
  return (
    <Drawer
      placement="right"
      // closable={false}
      width={1200}
      maskStyle={{ backgroundColor: "#000000CC" }}
      title="Upgrade Plan"
      onClose={onClosePlanUpgradeDrawer}
      visible={showPlanUpgradeDrawer}
    >
      <div className="mt-5">
        <h3 className="text-center pb-2 mb-0 text-black font-weight-600">
          A plan for every business
        </h3>
        <p className="text-center pb-3 font-weight-400">
          Choose a plan based on your business needs.
        </p>
        <div className="planList">
          {packageList
            ?.sort((a, b) => a.price - b.price)
            .map((singlePackage, index) => {
              return (
                <PlanElement
                  key={index}
                  index={index}
                  currentPlanData={subscriptionData}
                  publishableKey={
                    pricePackageData.get_stripe_setup.publishableKey
                  }
                  onChoosePlan={onChoosePlan}
                  {...singlePackage}
                />
              );
            })}
          <div className="pt-3 conditionApply">
            <small>
              * Please contact{" "}
              <a href="mailto:support@sanattest.com">support@sanattest.com</a>{" "}
              or <a href="tel:18337262883">1-833-726-2883</a> if you have more
              than 50 employees in 1 location.
            </small>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
export default PlanUpgradeModal;

export const PlanElement = (singlePlan) => {
  return (
    <div
      key={singlePlan.index}
      className={`planBox ${singlePlan?.name
        ?.toLowerCase()
        .replace(" ", "-")} plan_${singlePlan?.index} ${
        singlePlan.stripe_price_id ===
          singlePlan.currentPlanData.stripe_price_id && "currentPlanBox"
      }`}
    >
      <h4 className={`planName plan_${singlePlan?.index}`}>
        {singlePlan?.name}
      </h4>
      <div className="planPrice">
        <h2>
          <span>
            ${singlePlan?.price}
            <small>USD</small>
          </span>
          <p>Per location</p>
        </h2>
        <p>{singlePlan?.billing_period}</p>
      </div>
      <div className="planDetails pt-3 pb-3">
        <ul className="list-style pl-4 text-left">
          <li>Free Trial for {singlePlan?.free_trial_days} Days</li>
          <li>
            {singlePlan?.allow_custom_task} Custom tasks per employee per month
          </li>
          {singlePlan?.allow_qr_code && (
            <li>Scan QR Code to mark the task as complete</li>
          )}
          <li>Add up to 3 photos as proof of task completion</li>
        </ul>
      </div>
      {/* <div>{singlePlan.stripe_price_id}</div>
      <div>"Current Plan"{singlePlan.currentPlanData.plan.id}</div> */}
      {!(singlePlan.stripe_price_id === singlePlan.currentPlanData.plan.id) ? (
        <Button
          type="primary"
          shape="round"
          htmlType="submit"
          onClick={() => singlePlan.onChoosePlan(singlePlan.stripe_price_id)}
        >
          Select
        </Button>
      ) : (
        <Button
          type="primary"
          shape="round"
          className="currentPlanBtn"
          htmlType="submit"
        >
          Current Plan
        </Button>
      )}
    </div>
  );
};
